import React from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import StyledDrawer from "./StyledDrawer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "none",
    "@media screen and (max-width: 1290px)": {
      display: "block",
    },
  },
  list: {
    paddingTop: "40px",
    "& .MuiListItem-button": {
      borderRadius: "10px",
    },
  },
  divider: {
    width: "70%",
    height: "1px",
    transform: "translateX(-50%)",
    margin: "20px 0 20px 50%",
    backgroundColor: theme.palette.action.disabledBackground,
  },
  customerArea: {
    "& .MuiListItemIcon-root": {
      justifyContent: "flex-end",
    },
    "& .up svg": {
      transform: "rotate(180deg)",
      transition: "0.1s",
    },
    "& .down svg": {
      transform: "rotate(0deg)",
      transition: "0.1s",
    },
  },
}));

export default function HeaderDrawerMenu({ drawerOpen, setDrawerOpen }) {
  const classes = useStyles();

  return (
    <StyledDrawer
      open={drawerOpen}
      setOpen={setDrawerOpen}
      className={classes.root}
    >
      {/* TODO: ver com o vini se é isso mesmo */}
      <List className={classes.list}>
        <ListItem
          button
          id="conheca-conube-menu"
          onClick={() => {
            window.location.href = `${process.env.GATSBY_CONUBE_URL}/abrir-empresa`;
          }}
        >
          <ListItemText primary="Conheça a Conube" />
        </ListItem>
        <ListItem
          button
          id="abrir-empresa-menu"
          onClick={() => {
            window.location.href = `${process.env.GATSBY_CONUBE_URL}/abrir-empresa`;
          }}
        >
          <ListItemText primary="Abrir Empresa Grátis" />
        </ListItem>
      </List>
    </StyledDrawer>
  );
}

HeaderDrawerMenu.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  setDrawerOpen: PropTypes.func.isRequired,
};
